<template>
  <form id="form-shares"
        method="post"
        :action="action"
        @submit.prevent="onSubmit"
        @keydown="form.errors.clear($event.target.name)">
    
    <div class="form-item relative">
      <input type="text"
             name="name"
             class="form-control"
             :placeholder="Lang.get('common.name')"
             v-model="form.name"
      >
      <span class="help is-danger text-danger"
            v-if="form.errors.has('name')"
            v-text="form.errors.get('name')">
            </span>
    </div>
    
    <div class="form-item relative">
      <input type="text"
             name="phone"
             class="form-control mobilephone-input-mask"
             :placeholder="Lang.get('common.phone')"
             v-model="form.phone"
      >
      <span class="help is-danger text-danger"
            v-if="form.errors.has('phone')"
            v-text="form.errors.get('phone')">
            </span>
    </div>
    
    <div class="form-item relative">
      <input type="text"
             name="email"
             class="form-control"
             :placeholder="Lang.get('common.email')"
             v-model="form.email"
      >
      <span class="help is-danger text-danger"
            v-if="form.errors.has('email')"
            v-text="form.errors.get('email')">
            </span>
    </div>
    
    <div class="form-item relative select">
      <select v-model="form.country"
              name="country">
        <option value="selected">{{Lang.get('common.fly_to')}}</option>
        <option v-for="country in countries">{{ country }}</option>
      </select>
    </div>
    
    <input class="btn btn-success custom-button"
           type="submit"
           :disabled="form.errors.any()"
           :value="Lang.get('common.send_shares')">
    <widget-loading v-if="form.loading" color="#000"></widget-loading>
  
  </form>
</template>

<script>
    import WidgetLoading from '../elements/WidgetLoading';

    export default {
        name: "FormAttention",
        props: {
            countries: {
                required: true,
                type: Array
            }
        },
        components: {
            WidgetLoading,
        },
        data() {
            return {
                form: new Form({
                    name: '',
                    phone: '',
                    email: '',
                    country: 'selected',
                    type: 'form_attention',
                    url: location,
                }),
                action: Lang.locale === 'ua' ? '/extra-form-store' : '/ru/extra-form-store',
                Lang,
            }
        },
        methods: {
            onSubmit() {
                this.form.submit(this.$el.method, this.action).then(res => {
                    window.location = res;
                }).catch(error => console.log(error));
            },
        },
        mounted() {
            helpers.setInputMask('mobilephone');
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/FormAttention.vue